module.exports = __webpack_public_path__ + "img/img_main_txt01.194ca69c.svg";